<template>
    <v-app>
        <Navbar/>
        <v-main>
            <v-container fluid>
                <router-view/>
            </v-container>
            <cookie-law theme="dark-lime"/>
        </v-main>
    </v-app>
</template>

<script>
import Navbar from "@/views/components/Navbar.vue";
import CookieLaw from 'vue-cookie-law'
import {mapActions} from "vuex";

export default {
    name: 'App',
    components: {
        CookieLaw,
        Navbar,
    },
    methods: {
        ...mapActions({"load_data": "turbo_pancake/load_data"}),
        scrollToTop() {
            window.scrollTo(0, 0);
        }
    },
    async created() {
        // await this.load_data({})
        this.$gtag.pageview(this.$route)
    }
};
</script>
<style>


</style>
